// ONESCK – Make preview sock colour match swatch hex exactly
(function () {
  function getSelectedSwatches() {
    return document.querySelectorAll('button[class*="ai-match-color-swatch"].selected');
  }

  function getPreview(previewNum) {
    return document.querySelector('div[class^="ai-match-preview-sock-"][data-preview="' + previewNum + '"]');
  }

  function apply(previewEl, hex) {
    if (!previewEl || !hex) return;

    const color = String(hex).trim();
    previewEl.style.backgroundColor = color;
    previewEl.style.borderColor = color;

    // remove anything that changes perceived colour
    previewEl.style.opacity = "1";
    previewEl.style.filter = "none";
    previewEl.style.backgroundImage = "none";
    previewEl.style.boxShadow = "none";
    previewEl.style.outline = "none";
  }

  function update() {
    const selected = getSelectedSwatches();
    const p1 = getPreview(1);
    const p2 = getPreview(2);

    const s1 = selected[0];
    const s2 = selected[1];

    if (s1) apply(p1, s1.dataset.color || s1.getAttribute("data-color"));
    if (s2) apply(p2, s2.dataset.color || s2.getAttribute("data-color"));
  }

  document.addEventListener("click", function (e) {
    if (!e.target.closest('button[class*="ai-match-color-swatch"]')) return;
    setTimeout(update, 0); // let the tool update selection first
  });

  window.addEventListener("load", function () {
    setTimeout(update, 0);
  });
})();